import { Alert, TextInput } from '@ksyos/design-system';
import { isEmpty } from 'lodash';
import { memo, useCallback, useState } from 'react';
import { translateKey } from '../../translate';
import { getValidationErrorTranslation } from '../../utils/getValidationErrorTranslation';
import { HeaderDivider } from '../elements/common';
import { FormLabel } from '../elements/forms/FormLabel';
import { HorizontalFormGroup } from '../elements/forms/HorizontalFormGroup';
import { InputContainer } from '../elements/forms/InputContainer';
import { CheckboxField } from '../fields/Checkbox';
import { ProcessContainer } from '../pages/episodes/common';

export interface IEmailAddressControlProps {
    error: string | undefined;
    isChecked: boolean;
    isEmailKnown: boolean;
    onChange: React.ChangeEventHandler<HTMLInputElement>;
    onCheck: () => void;
    onDoValidate: React.FocusEventHandler<HTMLInputElement>;
    showCheckbox: boolean;
    showCheckboxWarning: boolean;
    value: string | undefined | null;
}

export const EmailAddressControl = memo(function (props: IEmailAddressControlProps) {
    const {
        value,
        error,
        isChecked,
        isEmailKnown,
        onChange,
        onCheck,
        onDoValidate,
        showCheckbox,
        showCheckboxWarning,
    } = props;
    const [isEmailEmpty, setIsEmailEmpty] = useState(isEmpty(value));

    const onChangeCallback = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            setIsEmailEmpty(isEmpty(event.target.value));
            onChange(event);
        },
        [onChange]
    );

    return (
        <ProcessContainer>
            <HeaderDivider text={translateKey('patient.detailsCounselling')} />

            {isEmailKnown && !showCheckbox && !showCheckboxWarning && (
                <Alert appearance="info">Controleer of het e-mailadres van de patiënt klopt</Alert>
            )}

            {isEmailEmpty && showCheckbox && !showCheckboxWarning && (
                <Alert appearance="info">
                    Voor de financiële afhandeling is het e-mailadres van de patiënt gewenst.{' '}
                </Alert>
            )}

            {isEmailEmpty && showCheckbox && showCheckboxWarning && (
                <Alert appearance="warning">
                    Let op: heeft de patiënt geen e-mailadres? Vink dit hieronder dan aan om verder te gaan.
                </Alert>
            )}

            <HorizontalFormGroup hasErrors={!isEmpty(error)}>
                <FormLabel>E-mailadres</FormLabel>
                <InputContainer>
                    <TextInput
                        error={getValidationErrorTranslation(error)}
                        onBlur={onDoValidate}
                        onChange={onChangeCallback}
                        value={value || ''}
                    />
                </InputContainer>
            </HorizontalFormGroup>

            {showCheckbox && (
                <CheckboxField
                    checked={isChecked}
                    label=""
                    onChange={onCheck}
                    text="Patiënt heeft geen e-mailadres"
                />
            )}
        </ProcessContainer>
    );
});
